import { Component, OnInit } from '@angular/core';
import { animate, transition, style, state, trigger, AUTO_STYLE } from '@angular/animations';
import { Router } from '@angular/router';

// Variables Globales
import { Globals } from '../../services/global/global';

// Models
import { User } from 'src/app/models/user.model';

// Services
import { AuthService } from 'src/app/services/auth/auth.service';
import { FirebasedatabaseService, IAbonados } from '../../services/firebase/firebasedatabase.service';
import { AudioService } from 'src/app/services/listening/audio.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { MonitoreoService } from '../../services/monitoreo/monitoreo.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: [
    './header.component.scss',
    '../../../assets/icon/icofont/css/icofont.scss'
  ],
  animations: [
    trigger('notificationBottom', [
      state('an-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('an-animate',
        style({
          overflow: 'hidden',
          height: AUTO_STYLE,
        })
      ),
      transition('an-off <=> an-animate', [
        animate('400ms ease-in-out')
      ])
    ]),
    trigger('slideInOut', [
      state('in', style({
        width: '300px',
        // transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        width: '0',
        // transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('mobileHeaderNavRight', [
      state('nav-off, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('nav-on',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('nav-off <=> nav-on', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})
export class HeaderComponent implements OnInit {

  user: User;

  img_perfil;

  macabonado: string | null = null;

  iconVolumen = 'icofont-volume-mute';

  ////////////////// PAGINATION  ABONADOS /////////////////////
  abonados: any[] = [];
  offset = 10;
  nextKey: any; // for next button
  prevKeys: any[] = []; // for prev button
  inicio = false; // flat button inicio
  ////////////////////////////////////////////////////////////

  subscription: Subscription;
  subEventMonitoreo: Subscription;

  constructor(
    public globals: Globals,
    public authService: AuthService,
    private router: Router,
    private audioService: AudioService,
    public firebaseDB: FirebasedatabaseService,
    private usuarioService: UsuarioService,
    private monitoreoService: MonitoreoService
  ) {
    this.audioService.setAudio('../../assets/audio/AlarmaSOS.mp3'); // ruta del audio
    this.globals.cont_evento = 0;
    this.firebaseDB.eventos = []; // colocamos acá esta variable para reliniciarla al salir de session
    this.inicialAudio();
  }

  ngOnInit() {
    this.user = this.authService.user;
    // this.url = window.location.pathname.substr(1);

    this.getdesconectados();
    this.listeningOffAlarmas();

    this.usuarioService.getPerfilAdmin().subscribe(data => {
      this.img_perfil = data[0].c_rutafoto;
    });

  }

  private getdesconectados() {
    this.monitoreoService.getAccesomoniteo()
      .subscribe((resp: any) => {
        if (resp.monitoreo) {
          this.firebaseDB.subscriptionNodoGrupos(resp.data.idmonitoreo, resp.data.idusuario);
        }
      });
  }

  inicialAudio() {
    this.audioService.AudioSource$
      .subscribe((audio: any) => {
        if (audio === 'icofont-volume-mute') {
          this.iconVolumen = audio;
          this.audioService.pauseAudio();
        } else {
          if (this.iconVolumen !== 'icofont-volume-bar') {
            this.iconVolumen = 'icofont-volume-bar';
            this.audioService.playAudio();
          }
        }
      });
  }

  audio() {
    if (this.firebaseDB.countAlarmas > 0) {
      if (this.iconVolumen === 'icofont-volume-mute') {
        this.iconVolumen = 'icofont-volume-bar';
        this.audioService.playAudio();
      } else {
        this.iconVolumen = 'icofont-volume-mute';
        this.audioService.pauseAudio();
      }
    }
  }

  logout() {

    if (this.iconVolumen !== 'icofont-volume-mute') {
      this.iconVolumen = 'icofont-volume-mute';
      this.audioService.pauseAudio();
    }
    this.authService.logout();
  }

  goPerfil() {
    this.router.navigateByUrl('/usuario/perfil');
  }

  nuevoEvento() {
    this.router.navigate(['/eventos/pendientes']);
  }

  nuevoReporte() {
    this.router.navigate(['/eventos/reporte']);
  }

  toggleOpened() {
    if (this.globals.windowWidth < 992) {
      this.globals.toggleOn = this.globals.verticalNavType === 'offcanvas' ? true : this.globals.toggleOn;
      if (this.globals.navRight === 'nav-on') {
        this.toggleHeaderNavRight();
      }
    }
    this.globals.verticalNavType = this.globals.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
  }

  onClickedOutsideSidebar(e: Event) {
    if ((this.globals.windowWidth < 992
      && this.globals.toggleOn
      && this.globals.verticalNavType !== 'offcanvas')
      || this.globals.verticalEffect === 'overlay') {
      this.globals.toggleOn = true;
      this.globals.verticalNavType = 'offcanvas';
    }
  }

  toggleHeaderNavRight() {
    this.globals.navRight = this.globals.navRight === 'nav-on' ? 'nav-off' : 'nav-on';
    this.globals.chatTopPosition = this.globals.chatTopPosition === 'nav-on' ? '112px' : '';
    if (this.globals.navRight === 'nav-off' && this.globals.innerChatSlideInOut === 'in') {
      this.toggleInnerChat();
    }
    if (this.globals.navRight === 'nav-off' && this.globals.chatSlideInOut === 'in') {
      this.toggleChat();
    }
  }

  toggleInnerChat() {
    this.globals.innerChatSlideInOut = this.globals.innerChatSlideInOut === 'out' ? 'in' : 'out';
  }

  toggleChat() {
    this.inicio = false;

    this.macabonado = null;
    this.globals.chatSlideInOut = this.globals.chatSlideInOut === 'out' ? 'in' : 'out';
    if (this.globals.innerChatSlideInOut === 'in') {
      this.globals.innerChatSlideInOut = 'out';
    }

    if (this.globals.chatSlideInOut === 'in') {
      this.getAbonados();
    } else {
      this.subscription.unsubscribe();
      // this.subEventMonitoreo.unsubscribe();
    }

  }

  getAbonados(key?: string | null) {
    this.abonados = [];

    this.monitoreoService.getAccesomoniteo()
      .subscribe((resp: any) => {
        if (resp.monitoreo) {

          let paran: IAbonados = {
            startKey: key,
            offset: this.offset
          };

          this.subscription = this.firebaseDB.subscriptionNodoAbonados1(paran, resp.data.idmonitoreo, resp.data.idgrupo)
            .subscribe((abonados: any) => {
              this.abonados = _.slice(abonados, 0, this.offset);
              this.nextKey = _.get(abonados[this.offset], 'key');
            });
        }
      });
  }

  filtroAbonado() {

    this.inicio = true;

    if (this.macabonado) {
      this.macabonado = this.macabonado.trim();
      let paran: IAbonados = {
        macabonado: this.macabonado
      };

      this.firebaseDB.filtarAbonados(paran);
    }
  }

  inicioPage() {
    this.inicio = false;
    let paran1: IAbonados = {
      offset: this.offset
    };

    this.firebaseDB.filtarAbonados(paran1);
  }

  nextPage() {
    this.prevKeys.push(_.first(this.abonados)['key']); // set current key as pointer for previous page
    // this.getAbonados(this.nextKey);
    this.inicio = true;

    let paran1: IAbonados = {
      offset: this.offset,
      startKey: this.nextKey
    };

    this.firebaseDB.filtarAbonados(paran1);
  }

  prevPage() {
    const prevKey = _.last(this.prevKeys); // use last key in array
    this.prevKeys = _.dropRight(this.prevKeys); // then remove the last key in the array
    // this.getAbonados(prevKey);

    let paran1: IAbonados = {
      offset: this.offset,
      startKey: prevKey
    };

    this.firebaseDB.filtarAbonados(paran1);
  }

  listeningOffAlarmas() {
    this.subEventMonitoreo = this.firebaseDB.onOffMonitoreosubject
      .subscribe((resp: any) => {

        this.abonados = [];
        this.offset = 10;
        this.nextKey = null;
        this.prevKeys = [];
        this.inicio = false;

        if (resp) {

          this.getAbonados();

        } else {
          this.subscription.unsubscribe();
        }

      });
  }

  searchOff() {
    const searchInterval = setInterval(() => {
      if (this.globals.searchWidth <= 0) {
        document.querySelector('#main-search').classList.remove('open');
        clearInterval(searchInterval);
        return false;
      }
      this.globals.searchWidth = this.globals.searchWidth - 15;
      this.globals.searchWidthString = this.globals.searchWidth + 'px';
    }, 35);
  }

  searchOn() {
    document.querySelector('#main-search').classList.add('open');
    const searchInterval = setInterval(() => {
      if (this.globals.searchWidth >= 200) {
        clearInterval(searchInterval);
        return false;
      }
      this.globals.searchWidth = this.globals.searchWidth + 15;
      this.globals.searchWidthString = this.globals.searchWidth + 'px';
    }, 35);
  }

  notificationOutsideClick(ele: string) {
    if (ele === 'live' && this.globals.liveNotification === 'an-animate') {
      this.toggleLiveNotification();
    } else if (ele === 'profile' && this.globals.profileNotification === 'an-animate') {
      this.toggleProfileNotification();
    }
  }

  toggleLiveNotification() {
    this.globals.liveNotification = this.globals.liveNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.globals.liveNotificationClass = this.globals.liveNotification === 'an-animate' ? 'active' : '';

    if (this.globals.liveNotification === 'an-animate' && this.globals.innerChatSlideInOut === 'in') {
      this.toggleInnerChat();
    }
    if (this.globals.liveNotification === 'an-animate' && this.globals.chatSlideInOut === 'in') {
      this.toggleChat();
    }
  }

  toggleProfileNotification() {
    this.globals.profileNotification = this.globals.profileNotification === 'an-off' ? 'an-animate' : 'an-off';
    this.globals.profileNotificationClass = this.globals.profileNotification === 'an-animate' ? 'active' : '';

    if (this.globals.profileNotification === 'an-animate' && this.globals.innerChatSlideInOut === 'in') {
      this.toggleInnerChat();
    }
    if (this.globals.profileNotification === 'an-animate' && this.globals.chatSlideInOut === 'in') {
      this.toggleChat();
    }
  }

}
